import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa, BasicApiResponseModel } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-audit-trail';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-audit-trail';
    this.httpClient = http;
  }

  /**
   * Get all audit trail data
   * @param visa API visa for authentication
   * @returns Observable with audit trail data
   */
  public getAll(visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}
